/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillOrderSalesRepsResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeBackfillOrderSalesRepsRequest, serializeBackfillOrderSalesRepsResponse, type BackfillOrderSalesRepsRequest, type BackfillOrderSalesRepsResponse, type ErrorResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/backfill-salesrep-snapshots
 */
export interface BackfillSalesrepSnapshotsRequestBuilder extends BaseRequestBuilder<BackfillSalesrepSnapshotsRequestBuilder> {
    /**
     * Re-resolves the primarySalesRep and takenBySalesRep snapshots on this organization's orders from their rep numbers, so ERP-imported orders carry the salesRepId the leaderboard, performance ranking and commission statements group on. Rep numbers that match no rep get the 'notassigned' sentinel and are listed in the response. Runs dry by default — send dryRun:false to write. Safe to re-run: unchanged orders are skipped, and previously unassigned orders are upgraded once their rep exists.
     * @param body Request to re-resolve the sales-rep snapshots on an organization's existing orders.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillOrderSalesRepsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: BackfillOrderSalesRepsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillOrderSalesRepsResponse | undefined>;
    /**
     * Re-resolves the primarySalesRep and takenBySalesRep snapshots on this organization's orders from their rep numbers, so ERP-imported orders carry the salesRepId the leaderboard, performance ranking and commission statements group on. Rep numbers that match no rep get the 'notassigned' sentinel and are listed in the response. Runs dry by default — send dryRun:false to write. Safe to re-run: unchanged orders are skipped, and previously unassigned orders are upgraded once their rep exists.
     * @param body Request to re-resolve the sales-rep snapshots on an organization's existing orders.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BackfillOrderSalesRepsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BackfillSalesrepSnapshotsRequestBuilderUriTemplate = "{+baseurl}/api/orders/backfill-salesrep-snapshots";
/**
 * Metadata for all the requests in the request builder.
 */
export const BackfillSalesrepSnapshotsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BackfillSalesrepSnapshotsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillOrderSalesRepsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBackfillOrderSalesRepsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
